module.exports = __webpack_public_path__ + "img/mein-title.3d069da1.png";